'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { Heading } from '@/components/typography/heading';
import { recoverFromChunkLoadFailure } from '@/lib/utils/chunk-load-recovery';

export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report first, reload second: chunk-load recovery must never swallow the
    // telemetry. Flush before any reload so the event is on the wire rather
    // than racing the navigation.
    Sentry.captureException(error);

    void Sentry.flush(2000).finally(() => {
      recoverFromChunkLoadFailure(error, { message: error.message });
    });
  }, [error]);

  return (
    <html lang='en'>
      <body>
        <div className='flex min-h-screen flex-col items-center justify-center p-4'>
          <div className='flex max-w-md flex-col items-center gap-4 text-center'>
            <Heading as='h2' size='2xl' className='text-destructive'>
              Something went wrong!
            </Heading>
            <p className='text-muted-foreground'>
              An unexpected error occurred. Our team has been notified and is
              working to fix the issue.
            </p>
            <button
              onClick={reset}
              className='bg-primary text-primary-foreground hover:bg-primary/90 rounded px-4 py-2'
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
